<template>
  <div class="d-flex flex-column">
    <h5>Informatie</h5>
    <information-editing
      v-if="isEditing"
    />
    <information-viewing
      v-else
    />
  </div>

  <hr class="my-1" />

  <google-map
    v-if="showMap"
    id="report-location-map"
    :initial-latitude="report?.latitude ?? 0"
    :initial-longitude="report?.longitude ?? 0"
  />
</template>

<script>
import GoogleMap from '@/components/UI/GoogleMap.vue';

import InformationEditing from './Editing.vue';
import InformationViewing from './Viewing.vue';

import ReportDetailStore from '@/store/pages/Report/report-detail-store';
import ReportEditStore, { EditState } from '@/store/pages/Report/report-edit-store';

import { getDateString, getTimeString } from '@/helpers/datetime';

export default {
  components: {
    InformationEditing,
    InformationViewing,
    GoogleMap,
  },

  computed: {
    report() {
      return ReportDetailStore.getters.isLoaded
        ? ReportDetailStore.getters.report
        : {
          createDate: 'Placeholder datum',
          address: 'Straat 01',
          zipCode: '0000XX',
          city: 'Plaatsnaam',
        };
    },

    isEditing() {
      return ReportEditStore.getters.state == EditState.editing
    },

    createDate() {
      if (!ReportDetailStore.getters.isLoaded) return '';

      let date = new Date(ReportDetailStore.getters.report.createDate);

      return `${getDateString(date)} // ${getTimeString(date)}`;
    },

    showMap: () => ReportDetailStore.getters.isLoaded,

    classes() {
      return {
        'mb-0': true,
        'placeholder': ReportDetailStore.getters.isLoading,
      }
    },
  },
  
}
</script>